import { View, Text, TouchableOpacity, Image, Platform } from "react-native";
import React, { useContext, useState } from "react";
import { ScrollView } from "react-native";
import { router } from "expo-router";
import { useDispatch, useSelector } from "react-redux";
import { useFocusEffect } from "@react-navigation/native";
import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import customAxios from "../../../utils/customAxios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import secureStorage from "../../../utils/secureStorage";
import { ActivityIndicator } from "react-native";
import { Toast } from "react-native-toast-notifications";
import Ionicons from "@expo/vector-icons/Ionicons";
import i18n, { availableLocales } from "../../../locales/i18n";
import StandardNavigation from "../../../components/navigation/StandardNavigation";
import { RootState } from "../../../store";
import { appActions } from "../../../store/slices/appSlice";
import { authActions } from "../../../store/slices/authSlice";
import SettingsHeaderIcon from "../../../assets/settings/gear.svg";
import WebSettingsScreen from "../../../components/web/WebSettingsScreen";
import Animated, { FadeInDown } from "react-native-reanimated";
import { deactivateDeviceToken } from "../../../lib/fcmNotifications";
import { notificationSocketService } from "../../../lib/notificationSocket";

const index = () => {
  const dispatch = useDispatch();

  const { sellWithScanner, locale } = useSelector(
    (state: RootState) => state.app,
  );

  const [showlanguages, setShowLanguages] = useState(false);
  const [showSalesMethod, setShowSalesMethod] = useState(false);

  // Respond to language changes immediately
  useFocusEffect(
    React.useCallback(() => {
      if (locale && i18n.locale !== locale) {
        i18n.locale = locale;
      }
    }, [locale]),
  );

  const ChangeLang = () => {
    setShowLanguages(true);
  };

  const toggleSalesMethod = () => {
    setShowSalesMethod(!showSalesMethod);
  };

  const handleSalesMethodChange = (withScanner: boolean) => {
    dispatch(appActions.toggleSellWithScanner());
    setShowSalesMethod(false);
  };

  const salesMethods = [
    {
      id: 1,
      value: true,
      title: i18n.t("scannerTitle"),
      subtitle: i18n.t("sellWithScannerDesc"),
    },
    {
      id: 2,
      value: false,
      title: i18n.t("sellWithoutScanner"),
      subtitle: i18n.t("sellWithoutScannerDesc"),
    },
  ];

  const [buttonSpinner2, setButtonSpinner2] = useState(false);

  const handelLogOut = async () => {
    setButtonSpinner2(true);
    try {
      const res = await customAxios.post(
        `/mobile/logout`,
        {
          refreshToken: await secureStorage.getItemAsync("refreshToken"),
        },
        { withCredentials: true },
      );

      Toast.show(res.data.message, {
        type: "success",
      });

      // Clear all auth data
      dispatch(authActions.setUser(null));
      dispatch(authActions.setAuthError(null));

      // Navigate to login
      router.push("/login");
    } catch (error) {
      Toast.show(i18n.t("logoutFailed"), {
        type: "danger",
      });

      // Even if server logout fails, clear local data
      dispatch(authActions.setUser(null));
      dispatch(authActions.setAuthError("Logout failed"));
      router.push("/login");
    } finally {
      // Deactivate push token & disconnect WebSocket
      try {
        await deactivateDeviceToken();
      } catch {}
      notificationSocketService.disconnect();
      // Always clear stored tokens regardless of server response
      await AsyncStorage.removeItem("accessToken");
      try {
        await secureStorage.deleteItemAsync("refreshToken");
      } catch (secureStoreError) {}
      setButtonSpinner2(false);
    }
  };
  const settings = [
    {
      id: 1,
      link: "profile",
      icon: require("../../../assets/settings/profile.png"),
      name: i18n.t("comptepersonel"),
    },
    {
      id: 2,
      link: "store-info",
      icon: require("../../../assets/settings/store-info.png"),
      name: i18n.t("storeInfo"),
    },
    {
      id: 3,
      link: "contact",
      icon: require("../../../assets/settings/mail.png"),
      name: i18n.t("contactus"),
    },
    {
      id: 4,
      link: "limits",
      icon: require("../../../assets/settings/profile.png"), // Using profile icon as placeholder
      name: i18n.t("limits"),
    },
    {
      id: 5,
      link: "update",
      icon: require("../../../assets/settings/update-up.png"),
      name: i18n.t("updateapp"),
    },
  ];

  // Render web version on web platform
  if (Platform.OS === "web") {
    return <WebSettingsScreen />;
  }

  return (
    <View style={{ flex: 1, backgroundColor: "#f0f0f0" }}>
      {/* Standard Navigation */}
      <StandardNavigation
        title={i18n.t("settings")}
        showBackButton={true}
        showMenuButton={true}
        showLogo={false}
        icon={<SettingsHeaderIcon width={30} height={30} />}
      />

      <ScrollView style={{ flex: 1, paddingHorizontal: 16, paddingTop: 16 }}>
        {/* Settings Options */}
        <View style={{ marginBottom: 20 }}>
          {settings.map((el, index) => (
            <Animated.View
              key={index}
              entering={FadeInDown.duration(400).delay(index * 100)}
            >
              <TouchableOpacity
                onPress={() => {
                  router.push(`/(drawer)/params/${el.link}` as any);
                }}
                style={{
                  backgroundColor: "white",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingVertical: 16,
                  paddingHorizontal: 20,
                  marginBottom: 12,
                  borderRadius: 12,
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: 1 },
                  shadowOpacity: 0.1,
                  shadowRadius: 2,
                  elevation: 2,
                }}
              >
                {/* Right side - Text and Icon */}
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    flex: 1,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      color: "#333",
                      fontWeight: "600",
                      textAlign: "right",
                      flex: 1,
                      marginRight: 12,
                    }}
                  >
                    {el.name}
                  </Text>
                  <Image
                    source={el.icon}
                    style={{ width: 24, height: 24 }}
                    resizeMode="contain"
                  />
                </View>

                {/* Left side - Arrow */}
                <MaterialIcons
                  name="arrow-back-ios"
                  size={16}
                  color="#999"
                  style={{ marginLeft: 8 }}
                />
              </TouchableOpacity>
            </Animated.View>
          ))}
        </View>

        {/* Sales Method Section */}
        <Animated.View
          entering={FadeInDown.duration(400).delay(settings.length * 100)}
          style={{ marginBottom: 20 }}
        >
          <Text
            style={{
              fontSize: 16,
              fontWeight: "bold",
              color: "#333",
              textAlign: "right",
              marginBottom: 12,
            }}
          >
            {i18n.t("salesMethod")}
          </Text>

          {!showSalesMethod ? (
            <TouchableOpacity
              onPress={toggleSalesMethod}
              style={{
                backgroundColor: "white",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingVertical: 16,
                paddingHorizontal: 20,
                borderRadius: 12,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.1,
                shadowRadius: 2,
                elevation: 2,
              }}
            >
              <View
                style={{ flexDirection: "row", alignItems: "center", flex: 1 }}
              >
                <View style={{ flex: 1, alignItems: "flex-end" }}>
                  <Text
                    style={{
                      fontSize: 16,
                      color: "#333",
                      fontWeight: "600",
                      textAlign: "right",
                      marginBottom: 2,
                    }}
                  >
                    {sellWithScanner
                      ? i18n.t("scannerTitle")
                      : i18n.t("sellWithoutScanner")}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color: "#666",
                      textAlign: "right",
                    }}
                  >
                    {sellWithScanner
                      ? i18n.t("sellWithScannerDesc")
                      : i18n.t("sellWithoutScannerDesc")}
                  </Text>
                </View>

                <View
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: 0,
                    width: 8,
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: sellWithScanner ? "#4CAF50" : "#FF9800",
                  }}
                  className="-translate-1/2"
                />
              </View>
              <MaterialIcons
                name="keyboard-arrow-down"
                size={20}
                color="#999"
              />
            </TouchableOpacity>
          ) : (
            <View>
              {salesMethods.map((method) => (
                <TouchableOpacity
                  key={method.id}
                  onPress={() => handleSalesMethodChange(method.value)}
                  style={{
                    backgroundColor:
                      sellWithScanner === method.value ? "#E3F2FD" : "white",
                    borderWidth: sellWithScanner === method.value ? 2 : 1,
                    borderColor:
                      sellWithScanner === method.value ? "#2196F3" : "#E0E0E0",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingVertical: 16,
                    paddingHorizontal: 20,
                    marginBottom: 8,
                    borderRadius: 12,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      flex: 1,
                    }}
                  >
                    <View style={{ flex: 1, alignItems: "flex-end" }}>
                      <Text
                        style={{
                          fontSize: 16,
                          color:
                            sellWithScanner === method.value
                              ? "#2196F3"
                              : "#333",
                          fontWeight:
                            sellWithScanner === method.value ? "600" : "400",
                          textAlign: "right",
                          marginBottom: 2,
                        }}
                      >
                        {method.title}
                      </Text>
                      <Text
                        style={{
                          fontSize: 12,
                          color:
                            sellWithScanner === method.value
                              ? "#2196F3"
                              : "#666",
                          textAlign: "right",
                        }}
                      >
                        {method.subtitle}
                      </Text>
                    </View>
                    {/* Remove the icon reference since it doesn't exist in the data structure */}
                  </View>
                  {sellWithScanner === method.value && (
                    <Ionicons
                      name="checkmark-circle"
                      size={20}
                      color="#2196F3"
                    />
                  )}
                </TouchableOpacity>
              ))}

              {/* Close button */}
              <TouchableOpacity
                onPress={() => setShowSalesMethod(false)}
                style={{
                  backgroundColor: "#F5F5F5",
                  paddingVertical: 12,
                  paddingHorizontal: 20,
                  borderRadius: 8,
                  marginTop: 8,
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    color: "#666",
                    fontWeight: "500",
                  }}
                >
                  {i18n.t("closeSalesMethod")}
                </Text>
              </TouchableOpacity>
            </View>
          )}
        </Animated.View>

        {/* Language Selection */}
        <Animated.View
          entering={FadeInDown.duration(400).delay(settings.length * 100 + 100)}
          style={{ marginBottom: 32 }}
        >
          {!showlanguages ? (
            <TouchableOpacity
              onPress={ChangeLang}
              style={{
                backgroundColor: "#9CA3AF",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingVertical: 16,
                paddingHorizontal: 20,
                borderRadius: 12,
              }}
            >
              <View
                style={{ flexDirection: "row", alignItems: "center", flex: 1 }}
              >
                <Text
                  style={{
                    fontSize: 16,
                    color: "white",
                    textAlign: "right",
                    flex: 1,
                    marginRight: 12,
                  }}
                >
                  {i18n.t("language")}
                </Text>
                <Image
                  source={require("../../../assets/settings/language.png")}
                  style={{ width: 24, height: 24 }}
                  resizeMode="contain"
                />
              </View>
              <MaterialIcons
                name="keyboard-arrow-down"
                size={20}
                color="white"
              />
            </TouchableOpacity>
          ) : (
            <View>
              {availableLocales.map((item) => (
                <TouchableOpacity
                  key={item.code + "drawer-params"}
                  onPress={() => {
                    setShowLanguages(false);
                    // setLocale now handles both i18n update and AsyncStorage persistence
                    dispatch(appActions.setLocale(item.code));
                  }}
                  style={{
                    backgroundColor: "white",
                    paddingVertical: 16,
                    paddingHorizontal: 20,
                    marginBottom: 8,
                    borderRadius: 12,
                    shadowColor: "#000",
                    shadowOffset: { width: 0, height: 1 },
                    shadowOpacity: 0.1,
                    shadowRadius: 2,
                    elevation: 2,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      color: "#333",
                      textAlign: "center",
                    }}
                  >
                    {item.name}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          )}
        </Animated.View>

        {/* Logout Button */}
        <Animated.View
          entering={FadeInDown.duration(400).delay(settings.length * 100 + 200)}
        >
          <TouchableOpacity
            style={{
              backgroundColor: "#EF4444",
              paddingVertical: 16,
              paddingHorizontal: 20,
              borderRadius: 12,
              marginBottom: 32,
            }}
            onPress={handelLogOut}
          >
            {buttonSpinner2 ? (
              <ActivityIndicator size="small" color="white" />
            ) : (
              <Text
                style={{
                  color: "white",
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: "600",
                }}
              >
                {i18n.t("logout")}
              </Text>
            )}
          </TouchableOpacity>
        </Animated.View>
      </ScrollView>
    </View>
  );
};

export default index;
